<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <EXCMRelationUserDataForm
              :relation="relation"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMRelationUserDataForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmrelationuserdata/create')

export default {
  components: {
    EXCMRelationUserDataForm,
    Loader
  },

  props: {
    relation: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.$route.name === 'EXCMRelationShow' || this.$route.name === 'EXCMRelationUpdate') {
        this.$store.state.modals.excmrelationuserdata.create.created = 1
        this.$store.state.modals.excmrelationuserdata.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMRelationUserDataUpdate', params: { id: created['@id'] } })
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
